import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Cellar from 'components/routes/Cellar'
import EventRoutes from 'components/routes/EventRoutes'
import ReservationView from 'components/routes/ReservationView'
import Reservation from 'components/routes/Reservation'
import GiftCard from 'components/routes/GiftCard'
import GiftCardRedirector from './GiftCardRedirector'

export class AppRoutes extends React.Component {
  render() {
    return (
      <Switch>
        <Route
          exact
          path="/:lang/:cellarId"
          component={Cellar}
        />
        <Route
          exact
          path="/:lang/:cellarId/events/:eventId/reservation/:reservationUuid/finalize"
          render={(props) => {
            return (<Reservation
              event={event}
              match={props.match}
              history={props.history}
            />)
          }}
        />
        <Route
          path="/:lang/:cellarId/events/:eventId"
          component={EventRoutes}
        />
        <Route
          exact
          path="/:lang/:cellarId/reservations/:reservationId"
          component={ReservationView}
        />
        <Route
          exact
          path="/:lang/:cellarId/gift-cards"
          component={GiftCardRedirector}
        />
        <Route
          exact
          path="/:lang/:cellarId/gift-cards/:giftCardId"
          component={GiftCard}
        />
      </Switch>
    )
  }
}

export default AppRoutes
